import { PropTypes } from 'preact-compat';
import { differenceInSeconds, parseISO } from 'date-fns';
import { actionTypes } from '../actions';

export const moduleName = 'bookings';

export const userProfileShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  nickname: PropTypes.string.isRequired,
  avatarUrl: PropTypes.string,
  pro: PropTypes.shape({
    costPerMinute: PropTypes.number.isRequired,
    service: PropTypes.string.isRequired,
  }),
});

export const bookingShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  client: userProfileShape.isRequired,
  pro: userProfileShape,
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['ONLINE', 'IN_PERSON']).isRequired,
  status: PropTypes.oneOf(['PRE_BOOKED', 'BOOKED', 'CANCELLED_BY_CLIENT', 'CANCELLED_BY_PRO', 'READY_TO_PURGE']).isRequired,
  viewed: PropTypes.bool.isRequired,
  paymentAmount: PropTypes.number.isRequired,
});

export const upcomingBookingsShape = PropTypes.arrayOf(bookingShape);

export const selectUpcomingBookingsState = (state) => state.bookings;

export const selectUpcomingBookingsData = (state) => state.bookings.upcomingBookings;

export const selectAreUpcomingBookingsLoading = (state) => state.bookings.loading;

export const selectDidUpcomingBookingsLoadingFailed = (state) => state.bookings.error;

export const selectLastCancelledBookingId = (state) => state.bookings.lastCancelledBookingId;

export const selectBookingBeingCancelled = (state) => state.bookings.bookingBeingCancelled;

const initialState = {
  upcomingBookings: [],
  error: false,
  loading: false,
  lastCancelledBookingId: null,
};

const extractRefundAmountfromDetailsPayload = (payload) => (payload.details
  ? payload.details
    ? payload.details.refundData
      ? payload.details.refundData.amount
      : 0
    : 0
  : 0);

const extractBookingIdFromDetailsPayload = (payload) => (payload.booking
  ? payload.booking.id
  : null);

const extractPaymentAmountFromDetailsPayload = (payload) => (payload.booking
  ? payload.booking.paymentAmount
  : null);

const extractBookingStartTimeFromDetailsPayload = (payload) => (payload.booking
  ? parseISO(payload.booking.startTime)
  : null);

export default (state = { ...initialState }, action) => {
  switch (action.type) {
    case actionTypes.GET_BOOKINGS_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
        lastCancelledBookingId: null,
        bookingBeingCancelled: null,
      };
    case actionTypes.GET_BOOKINGS_FAILURE:
      return {
        upcomingBookings: [],
        error: true,
        loading: false,
      };
    case actionTypes.GET_BOOKINGS_SUCCESS:
      return {
        upcomingBookings: action.payload,
        error: false,
        loading: false,
      };
    case actionTypes.CANCEL_BOOKING_SUCCESS:
      return {
        ...state,
        lastCancelledBookingId: action.payload.id,
        bookingBeingCancelled: null,
      };
    case actionTypes.GET_BOOKING_REFUND_SUCCESS:
      return {
        ...state,
        bookingBeingCancelled: {
          id: extractBookingIdFromDetailsPayload(action.payload),
          refundAmount: extractRefundAmountfromDetailsPayload(action.payload),
          amIClient: action.payload.userId === action.payload.booking.client.id,
          paymentAmount: extractPaymentAmountFromDetailsPayload(action.payload),
          secondsToStart: differenceInSeconds(
            extractBookingStartTimeFromDetailsPayload(action.payload),
            new Date(),
          ),
        },
      };
    case actionTypes.CANCEL_BOOKING_NOT_CONFIRMED:
      return {
        ...state,
        bookingBeingCancelled: null,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/bookings.js